import { useEffect, useState } from 'react';
import { REVIVE_NIGHTS } from '../data/events';

// Runtime Revive Nights schedule, managed from /admin without a redeploy.
// Falls back to the baked schedule if the store is empty or unreachable,
// so the site never shows a blank calendar.
const CACHE_KEY = 'rw-events';

function readCache() {
  try {
    const raw = window.sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const list = JSON.parse(raw);
    return Array.isArray(list) && list.length ? list : null;
  } catch {
    return null;
  }
}

export default function useEvents() {
  const [events, setEvents] = useState(() => readCache() || REVIVE_NIGHTS);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch('/.netlify/functions/events');
        if (!res.ok) throw new Error('bad status');
        const data = await res.json();
        const list = Array.isArray(data.events) ? data.events : [];
        if (!alive) return;
        if (list.length) {
          setEvents(list);
          try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(list)); } catch {}
        } else {
          // Store cleared: drop the stale cache too, or later mounts this
          // session would flash the withdrawn schedule before correcting.
          setEvents(REVIVE_NIGHTS);
          try { window.sessionStorage.removeItem(CACHE_KEY); } catch {}
        }
      } catch {
        // Baked schedule already in place.
      }
    })();
    return () => { alive = false; };
  }, []);

  return events;
}
